import $ from "jquery";

export default function themeProduct() {
  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  };

  theme.Product = (function () {
    var selectors = {
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      comparePrice: "[data-compare-price]",
      comparePriceText: "[data-compare-text]",
      originalSelectorId: "[data-product-select]",
      priceWrapper: "[data-price-wrapper]",
      productFeaturedImage: "[data-product-featured-image]",
      productJson: "[data-product-json]",
      productPrice: "[data-product-price]",
      productThumbs: "[data-product-single-thumbnail]",
      singleOptionSelector: "[data-single-option-selector]",
    };

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
      this.$container = $(container);

      // Stop parsing if we don't have the product json script tag when loading
      // section in the Theme Editor
      if (!$(selectors.productJson, this.$container).html()) {
        return;
      }

      var sectionId = this.$container.attr("data-section-id");
      this.productSingleObject = JSON.parse(
        $(selectors.productJson, this.$container).html()
      );

      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data("enable-history-state") || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject,
      };

      this.settings = {};
      this.namespace = ".product";
      this.variants = new slate.Variants(options);
      this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

      this.$container.on(
        "variantChange" + this.namespace,
        this.updateAddToCartState.bind(this)
      );
      this.$container.on(
        "variantPriceChange" + this.namespace,
        this.updateProductPrices.bind(this)
      );

      if (this.$featuredImage.length > 0) {
        this.settings.imageSize = slate.Image.imageSize(
          this.$featuredImage.attr("src")
        );
        slate.Image.preload(
          this.productSingleObject.images,
          this.settings.imageSize
        );

        this.$container.on(
          "variantImageChange" + this.namespace,
          this.updateProductImage.bind(this)
        );
      }
    }

    Product.prototype = $.extend({}, Product.prototype, {
      /**
       * Updates the DOM state of the add to cart button
       *
       * @param {boolean} enabled - Decides whether cart is enabled or disabled
       * @param {string} text - Updates the text notification content of the cart
       */
      updateAddToCartState: function (evt) {
        var variant = evt.variant;
        if (variant) {
          $(selectors.priceWrapper, this.$container).removeClass("hide");
          setTimeout(function () {
            $("#addCartBtn").show().prop("disabled", false);
            $("#BIS_trigger_custom").hide();
          }, 100);
        } else {
          $(selectors.addToCart, this.$container).prop("disabled", true);
          $(selectors.addToCartText, this.$container).html(
            theme.strings.unavailable
          );
          $(selectors.priceWrapper, this.$container).addClass("hide");
          setTimeout(function () {
            $("#addCartBtn").hide();
            $("#BIS_trigger_custom").show();
          }, 100);
          return;
        }

        if (variant.available) {
          $(selectors.addToCart, this.$container).prop("disabled", false);
          $(selectors.addToCartText, this.$container).html(
            theme.strings.addToCart
          );
          setTimeout(function () {
            $("#BIS_trigger_custom").hide();
            $("#addCartBtn").show().prop("disabled", false);
          }, 100);
        } else {
          $(selectors.addToCart, this.$container).prop("disabled", true);
          $(selectors.addToCartText, this.$container).html(
            theme.strings.soldOut
          );
          setTimeout(function () {
            $("#addCartBtn").hide();
            $("#BIS_trigger_custom").show();
          }, 100);
        }

        $("#BIS_trigger_custom").on("click", function () {
          $(".js-popup").addClass("open");
          $(".c-popupOverlay").addClass("open");

          $(".js-popup input.name").val("");
          $(".js-popup .email").val("");
          $(".jsBisSuc").hide();

          var Men = "Men";
          var Women = "Women";

          var proTitle = variant.title;

          var progender = variant.option1;

          var prosize = variant.option3;

          var womentitle = variant.title;

          if (
            typeof variant.inventory_policy == "undefined" &&
            variant.title.indexOf(Men) != -1
          ) {
            var upTitle = progender.replace("Men", "Women");

            var upSizeNum = parseFloat(prosize);

            var upSizeCorrect = upSizeNum + 1.5;

            $(".js-popup input.name").val(upTitle + " / " + upSizeCorrect);
          } else if (
            typeof variant.inventory_policy == "undefined" &&
            variant.title.indexOf(Women) != -1
          ) {
            var upTitleMen = progender.replace("Women", "Men");

            var upSizeNumMen = parseFloat(prosize);

            var upSizeCorrectMen = upSizeNumMen - 1.5;

            $(".js-popup input.name").val(
              upTitleMen + " / " + upSizeCorrectMen
            );
          } else {
            $(".js-popup input.name").val(progender + " / " + prosize);
          }

          return;
        });

        var notificationCallback = function (data) {
          if (data.status == "Error") {
            const { errors } = data;
            $(".jsBisError").show();

            if (errors.phone_number) {
              $(".jsBisError").text(errors.phone_number);
            } else if (errors.email) {
              $(".jsBisError").text(errors.email);
            } else if (errors.base) {
              $(".jsBisError").text(errors.base);
            }
            return;
          } else if (data.status == "OK") {
            $(".jsBisSuc").show();
            $(".jsBisError").hide();

            setTimeout(function () {
              $(".js-popup").removeClass("open");
              $(".c-popupOverlay").removeClass("open");
              $(".jsBisError").hide();
            }, 2000);
          }
          return;
        };

        $(".js-size").on("click", function () {
          var $varint_selected_size = $(this).text();
          window.localStorage.setItem("size_selection", $varint_selected_size);
        });

        function sizeSelection() {
          var $get_prev_size = localStorage.getItem("size_selection");
          $('[data-shoe-size="' + $get_prev_size + '"]').trigger("click");
        }

        sizeSelection();

        $(".c-popupBody_number").on("change", function () {
          if ($(this).val().length > 0) {
            $(".email").attr("disabled", true);
            $(".email").addClass("input-disabled");
          } else {
            $(".email").attr("disabled", false);
            $(".email").removeClass("input-disabled");
          }
        });

        $(".c-popupBody_number").on("focus", function () {
          $(".email").attr("disabled", true);
          $(".email").addClass("input-disabled-focus");
        });

        $(".c-popupBody_number").on("focusout", function () {
          $(".email").attr("disabled", false);
          $(".email").removeClass("input-disabled-focus");
        });

        $(".email").on("change", function () {
          if ($(this).val().length > 0) {
            $(".c-popupBody_number").attr("disabled", true);
            $(".c-popupBody_number").addClass("input-disabled");
          } else {
            $(".c-popupBody_number").attr("disabled", false);
            $(".c-popupBody_number").removeClass("input-disabled");
          }
        });

        $(".email").on("focus", function () {
          $(".c-popupBody_number").attr("disabled", true);
          $(".c-popupBody_number").addClass("input-disabled-focus");
        });

        $(".email").on("focusout", function () {
          $(".c-popupBody_number").attr("disabled", false);
          $(".c-popupBody_number").removeClass("input-disabled-focus");
        });

        $("#JSsend")
          .unbind("click")
          .on("click", function () {
            var url = window.location.href;
            var id = url.substring(url.lastIndexOf("?variant=") + 1);
            var varID = id.match(/\d/g);
            var numb = varID.join("");
            var capEmail = $(".js-popup .email").val();
            var capPhone = $(".js-popup .c-popupBody_number").val();
            if (capPhone[0] != "+") {
              capPhone = "+" + capPhone;
            }

            var capProID = parseInt(productId);

            if (typeof variant.inventory_policy == "undefined") {
              console.log(1);
              if (capEmail.length > 0) {
                console.log(11);
                BIS.create(capEmail, numb, oppositeGenderID).then(
                  notificationCallback
                );
              } else {
                console.log(12);
                BIS.create(null, numb, oppositeGenderID, {
                  phone_number: capPhone,
                }).then(notificationCallback);
              }
            } else {
              console.log(2);
              if (capEmail.length > 0) {
                console.log(21);
                BIS.create(capEmail, numb, capProID).then(notificationCallback);
              } else {
                console.log(22);
                BIS.create(null, numb, capProID, {
                  phone_number: capPhone,
                }).then(notificationCallback);
              }
            }
          });
      },

      /**
       * Updates the DOM with specified prices
       *
       * @param {string} productPrice - The current price of the product
       * @param {string} comparePrice - The original price of the product
       */
      updateProductPrices: function (evt) {
        var variant = evt.variant;
        var $comparePrice = $(selectors.comparePrice, this.$container);
        var $compareEls = $comparePrice.add(
          selectors.comparePriceText,
          this.$container
        );

        $(selectors.productPrice, this.$container).html(
          slate.Currency.formatMoney(variant.price, theme.moneyFormat)
        );

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(
            slate.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          );
          $compareEls.removeClass("hide");
        } else {
          $comparePrice.html("");
          $compareEls.addClass("hide");
        }
      },

      /**
       * Updates the DOM with the specified image URL
       *
       * @param {string} src - Image src URL
       */
      updateProductImage: function (evt) {
        var variant = evt.variant;
        var sizedImgUrl = slate.Image.getSizedImageUrl(
          variant.featured_image.src,
          this.settings.imageSize
        );

        this.$featuredImage.attr("src", sizedImgUrl);
      },

      /**
       * Event callback for Theme Editor `section:unload` event
       */
      onUnload: function () {
        this.$container.off(this.namespace);
      },
    });

    return Product;
  })();

  $(".c-abShipping").click(function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("#delivery").offset().top,
      },
      2000
    );
  });

  if (window.countryCode == "US" || window.countryCode == "IN") {
    $(".c-afterpayBody").addClass("visible");
  }

  $(".js-logo").on("click", function () {
    $(".c-popupOverlay").addClass("open");
    $(".js-afterPay").addClass("open");
  });

  $(".c-stickyBarPdp__button").on("click", function () {
    // var gridBoxTop = $('.c-pdp__gridBox').position().top
    // $(window).animate({scrollTop: gridBoxTop}, 1000 );
    $("html, body").animate(
      {
        scrollTop: $(".c-pdp__gridBox").offset().top - 105,
      },
      500
    );
  });

  $(".js-top").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(".c-pdp__gridBox").offset().top - 100,
      },
      500
    );
    return false;
  });

  var freeShippingBar = setInterval(function () {
    if ($(".notice-bar").length) {
      var noticeBarBanner = $(".c-stickyBarPdp__notice-bar");
      noticeBarBanner.text(window.promoMessages.getPdpMessage().message);
      clearInterval(freeShippingBar);
    }
  }, 1000);

  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleWindowResize);
  var addToCartButtonOffSet;
  var headerHeight;

  if (window.innerWidth >= 992) {
    headerHeight = $(".main-header").height();
  } else {
    headerHeight = $(".header-control").height();
  }

  //Without this, it won't be able to get precise position of button due to the fact of image lazy load
  let checkLazyloadInterval = setInterval(() => {
    if ($(".pdp-addCartBtn-sticky").css("display") == "none") {
      addToCartButtonOffSet =
        $(".bis_notify_trigger").offset().top +
        $(".bis_notify_trigger").outerHeight();
    } else {
      addToCartButtonOffSet =
        $(".pdp-addCartBtn-sticky").offset()?.top +
        $(".pdp-addCartBtn-sticky").outerHeight();
    }
    clearInterval(checkLazyloadInterval);
  }, 1500);
  //Handle Resize to get button position
  function handleWindowResize() {
    if (window.innerWidth > 992) {
      headerHeight = $(".main-header").height();
    }

    addToCartButtonOffSet =
      $(".pdp-addCartBtn-sticky").offset().top +
      $(".pdp-addCartBtn-sticky").outerHeight();
  }

  function handleScroll() {
    const buyboxOffset =
      $(".c-pdp__grid").offset()?.top +
      $(".c-pdp__grid").outerHeight();
    //When the user scroll down that pass the button position
    if (window.scrollY + headerHeight > buyboxOffset) {
      if (!$(".c-stickyBarPdp").hasClass("drop-animation")) {
        if (window.innerWidth > 992) {
          $(".top-nav__bottom").addClass("translate-top");
          $(".top-nav__bottom").removeClass("translate-bottom");

          $(".template-product").removeClass("has-notice-bar");
          if (window.noticeBarIns) window.noticeBarIns.autoplay.pause()
          $("#notice-bar").hide();

          setTimeout(() => {
            $(".c-stickyBarPdp").removeClass("hidden-sticky-block");
          }, 200);
        }
      }
      $(".js-top").addClass("visible");
    } else {
      //wnen the user scroll up that pass the button position
      if (!$(".c-stickyBarPdp").hasClass("hidden-sticky-block")) {
        if (window.innerWidth > 992) {
          if (window.noticeBar.isShow) {
            $(".template-product").addClass("has-notice-bar");
            $("#notice-bar").show();
          }
          if (window.noticeBarIns) window.noticeBarIns.autoplay.run()

          setTimeout(() => {
            $(".c-stickyBarPdp").addClass("hidden-sticky-block");

            $(".top-nav__bottom").removeClass("translate-top");
            $(".top-nav__bottom").addClass("translate-bottom");
          }, 200);
        }
      }
      $(".js-top").removeClass("visible");
    }
  }

  const handleScrollForStickyAddToCart = () => {
    const addToCartButton = $('.pdp-addCartBtn-sticky:not(:hidden), #addCartBtn:not(:hidden), .c-abBtnAtc--checkout:not(:hidden)')

    if (addToCartButton.length === 0) {
      if (!$('.sticky-add-to-cart').hasClass('hidden-sticky-block')) {
        $('.sticky-add-to-cart').addClass('hidden-sticky-block')
      }

      return
    }

    const addToCartButtonOffSet = addToCartButton.offset().top + addToCartButton.outerHeight()

    if (window.scrollY + headerHeight > addToCartButtonOffSet) {
      setTimeout(() => {
        if (addToCartButton.is(':disabled')) {
          $('.sticky-add-to-cart__button').attr('disabled', 'disabled')
        } else if (!addToCartButton.is('#BIS_trigger_custom')) {
          $('.sticky-add-to-cart__button').removeAttr('disabled')
        }

        $('.sticky-add-to-cart').removeClass('hidden-sticky-block')
      })
    } else {
      if (!$('.sticky-add-to-cart').hasClass('hidden-sticky-block')) {
        setTimeout(() => {
          $('.sticky-add-to-cart').addClass('hidden-sticky-block')
        })
      }
    }
  }

  window.addEventListener('scroll', handleScrollForStickyAddToCart)
}
